import { Injectable } from '@angular/core';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { SocketService } from './socket.service';
import { GlobalsService } from './globals.service';
import * as FileSaver from 'file-saver';
import { ValidationErrors } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';


declare let $: any;

@Injectable({
	providedIn: 'root'
})
//using as globals
export class GlobalSearchService {
	config: any = [];
	bound_user: any = [];
	filteredItems: any = [];
	color = 'blue';
	collapseMini: any = false;

	public searchTerm: BehaviorSubject < string > = new BehaviorSubject < string > (null);

	public dispatchNote: BehaviorSubject < string > = new BehaviorSubject < string > (null);
	public invoiceNote: BehaviorSubject < string > = new BehaviorSubject < string > (null);
	public poEntered: BehaviorSubject < string > = new BehaviorSubject < string > (null);

	public lastCustomer: BehaviorSubject < any > = new BehaviorSubject < any > (null);

	public empCode: BehaviorSubject < any > = new BehaviorSubject < any > (null);


	public lastCustomerTrans: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public lastItem: BehaviorSubject < any > = new BehaviorSubject < any > (null);

	public selectedlocation: BehaviorSubject < any > = new BehaviorSubject < any > (null);

	public datasets: BehaviorSubject < any > = new BehaviorSubject < any > (null);

	public discountsAllowed: BehaviorSubject < string > = new BehaviorSubject < string > (null);

	public user: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public mesagesallowed: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public userData: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public locationData: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public orderData: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public searchResults: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public customerData: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public vendorData: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public openOrderData: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public messages: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public pickingOrderData: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public allItems: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public socket: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public currentOrderList: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public orderSearch: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public itemSearch: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public orderResults: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public package: BehaviorSubject < any > = new BehaviorSubject < any > (null);

	//globals
	public taxgroups: BehaviorSubject < any > = new BehaviorSubject < any > (null);

	public reloadorder: BehaviorSubject < any > = new BehaviorSubject < any > (null);

	public salespeople: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public shipvia: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public terms: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public zones: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public holdreasons: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public currencies: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public salestypes: BehaviorSubject < any > = new BehaviorSubject < any > (null);

	public all_system_types: BehaviorSubject < any > = new BehaviorSubject < any > (null);

	public locations: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public areas: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public customertypes: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public payment_methods: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public bankaccounts: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public company: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public configsubscription: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public aiDataAvailable$: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public aiDataContext$: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public aiDataResults$: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	
	public helpManualAvailable$: BehaviorSubject < any > = new BehaviorSubject < any > (null);

	// CRM Types
	public crm_types: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public lead_statuses: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public opportunity_stages: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public activity_types: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public lead_sources: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public lost_reasons: BehaviorSubject < any > = new BehaviorSubject < any > (null);
	public currentsetuser = false;
	public localStorageKey = 'v8ConfigOverride';
	private preOrder: any = false;

	constructor(private http: HttpClient,private _configSvc: RuntimeConfigLoaderService, private socketService: SocketService, private globalsService: GlobalsService) {

		this.config = this.loadConfigFromLocalStorage();
		this.configsubscription.next(this.config);
		this.reloadorder.next(false);
		//only functioning while logged in user value.
		if (this.config) {
			this.discountsAllowed.next(this.config.discounts);
		}
		// Listen for group permission updates via socket
		this.socketService.subscribeToGroupUpdate((err, data) => {
			if (err) {
				console.error('Socket group update error:', err);
				return;
			}
			
			if (data) {
				console.log('Group permissions updated - refetching user data');
				
				// Refetch current user's permissions
				this.socketService.getUserUpdate(this.user.value).subscribe(
					async (result: any) => {
						if (result.pass) {
							// Update user settings throughout the app
							this.userData.next(result.user);
							this.user.next(result);
							this.currentsetuser = result;
							localStorage.setItem('user', JSON.stringify(result));
							
							// Show notification to user
							this.showNotification(
								'Your permissions have been updated', 
								'info', 
								'top', 
								'right'
							);
						}
					},
					(error) => {
						console.error('Failed to refetch user permissions:', error);
					}
				);
			}
		});

		// Handle user changes and location loading
		this.user.subscribe(changed => {
			if (changed !== null) {
				if (changed.pass) {
					if (changed && this.currentsetuser != changed) {
						this.currentsetuser = changed;
						this.globalsService.getUserLocations().subscribe({
							next: (results: any) => this.locations.next(results),
							error: (err) => console.error('Failed to load user locations:', err)
						});
					}
				}
			}
		});
		// Load critical globals first, then secondary data in background
		this.loadCriticalGlobals();
		setTimeout(() => this.loadSecondaryGlobals(), 100);
	}

	loadCriticalGlobals() {
		// Load only the most essential data first
		forkJoin({
			company: this.globalsService.getCompany(),
			userLocations: this.globalsService.getUserLocations(),
			currencies: this.globalsService.getCurrencies()
		}).subscribe({
			next: (results) => {
				this.company.next(results.company);
				this.locations.next(results.userLocations);
				this.currencies.next(results.currencies);
			},
			error: (error) => {
				console.error('Failed to load critical globals:', error);
			}
		});
	}

	loadSecondaryGlobals() {
		// Load secondary data in background
		const loadObservables: any = {
			taxes: this.globalsService.getTaxes(),
			salespeople: this.globalsService.getSalesman(),
			shipVia: this.globalsService.getShipVia(),
			terms: this.globalsService.getTerms(),
			holdReasons: this.globalsService.getHoldReasons(),
			defaultZones: this.globalsService.getDefaultZones(),
			salesTypes: this.globalsService.getSalesTypes(),
			areas: this.globalsService.getAreas(),
			customerTypes: this.globalsService.getCustomerTypes(),
			systemTypes: this.globalsService.getTypes(),
			paymentMethods: this.globalsService.getPaymentMethods(),
			bankAccounts: this.globalsService.getBankAccounts()
		};

		forkJoin(loadObservables).subscribe({
			next: (results: any) => {
				this.taxgroups.next(results.taxes);
				this.salespeople.next(results.salespeople);
				this.shipvia.next(results.shipVia);
				this.terms.next(results.terms);
				this.holdreasons.next(results.holdReasons);
				this.zones.next(results.defaultZones);
				this.salestypes.next(results.salesTypes);
				this.areas.next(results.areas);
				this.customertypes.next(results.customerTypes);
				this.all_system_types.next(results.systemTypes);
				this.payment_methods.next(results.paymentMethods);
				this.bankaccounts.next(results.bankAccounts);
			},
			error: (error) => {
				console.error('Failed to load secondary globals:', error);
			}
		});
	}
	
	loadManualMarkdown(routePath: string) {
	  const filename = routePath
			? `${routePath.replace(/\//g, '_')}_MANUAL.md`
			: 'root_MANUAL.md';
	
	  return this.http.get(`assets/manuals/${filename}`, { responseType: 'text' });
	}

	setPreOrder(data: any) {
		this.preOrder = data;
	}

	getPreOrder() {
		return this.preOrder;
	}

	loadConfigFromLocalStorage(): any {
		const localConfig = localStorage.getItem(this.localStorageKey);

		if (localConfig) {
			try {
				const config = JSON.parse(localConfig);
				if (this.isValidConfig(config)) {
					//console.log('Using local storage config:', config);
					return config;
				} else {
					//console.warn('Local storage config is invalid. Falling back to default config.');
					return this.getDefaultConfig();
				}
			} catch (error) {
				//console.error('Failed to parse local storage config. Falling back to default config:', error);
				return this.getDefaultConfig();
			}
		} else {
			//console.warn('No local storage config found. Using default config.');
			return this.getDefaultConfig();
		}
	}

	isValidConfig(config: any): boolean {
		if (!config) {
			//'Configuration is null or undefined.');
			return false;
		}
		if (typeof config.apiCredentials.clientId !== 'string') {
			//'Invalid or missing "clientId":', config.apiCredentials.clientId);
			return false;
		}
		if (!config.env || typeof config.env.package !== 'string') {
			//'Invalid or missing "env.package":', config.env);
			return false;
		}
		return true;
	}

	private getDefaultConfig(): any {
		this.config = this._configSvc.getConfig();
		return this.config;
	}

	updatePaymentMethods() {
		this.globalsService.getPaymentMethods().subscribe({
			next: (results: any) => this.payment_methods.next(results),
			error: (err) => console.error('Failed to update payment methods:', err)
		});
	}

	getConfig() {
		return this.config;
	}

	/** Client config `saveToProfileDefault` for card forms; defaults to true when unset. */
	getSaveToProfileDefault(): boolean {
		const v = this.config?.saveToProfileDefault;
		if (typeof v === 'boolean') {
			return v;
		}
		if (v === 'true' || v === 1) {
			return true;
		}
		if (v === 'false' || v === 0) {
			return false;
		}
		return true;
	}

	reload() {

		this.discountsAllowed.next(this.config.discounts);
		this.socketService.subscribeToGroupUpdate((err, data) => {
			if (data) {
				this.socketService.getUserUpdate(this.user.value).subscribe({
					next: (result: any) => {
						if (result?.pass) {
							this.userData.next(result.user);
							this.user.next(result);
							localStorage.setItem('user', JSON.stringify(result));
						}
					},
					error: (e) => console.error('Failed to get user update:', e)
				});
			}
		});

		const onErr = (label: string) => (e: any) => console.error(`Failed to load ${label}:`, e);
		this.globalsService.getTaxes().subscribe({ next: (r: any) => this.taxgroups.next(r), error: onErr('taxes') });
		this.globalsService.getSalesman().subscribe({ next: (r: any) => this.salespeople.next(r), error: onErr('salesman') });
		this.globalsService.getShipVia().subscribe({ next: (r: any) => this.shipvia.next(r), error: onErr('shipVia') });
		this.globalsService.getTerms().subscribe({ next: (r: any) => this.terms.next(r), error: onErr('terms') });
		this.globalsService.getHoldReasons().subscribe({ next: (r: any) => this.holdreasons.next(r), error: onErr('holdReasons') });
		this.globalsService.getDefaultZones().subscribe({ next: (r: any) => this.zones.next(r), error: onErr('zones') });
		this.globalsService.getUserLocations().subscribe({ next: (r: any) => this.locations.next(r), error: onErr('locations') });
		this.globalsService.getCurrencies().subscribe({ next: (r: any) => this.currencies.next(r), error: onErr('currencies') });
		this.globalsService.getSalesTypes().subscribe({ next: (r: any) => this.salestypes.next(r), error: onErr('salesTypes') });
		this.globalsService.getAreas().subscribe({ next: (r: any) => this.areas.next(r), error: onErr('areas') });
		this.globalsService.getCustomerTypes().subscribe({ next: (r: any) => this.customertypes.next(r), error: onErr('customerTypes') });
		this.globalsService.getTypes().subscribe({ next: (r: any) => this.all_system_types.next(r), error: onErr('systemTypes') });
		this.globalsService.getPaymentMethods().subscribe({ next: (r: any) => this.payment_methods.next(r), error: onErr('paymentMethods') });
		this.globalsService.getBankAccounts().subscribe({ next: (r: any) => this.bankaccounts.next(r), error: onErr('bankAccounts') });
		this.globalsService.getCompany().subscribe({ next: (r: any) => this.company.next(r), error: onErr('company') });
	}

	reloadLocations() {
		this.globalsService.getUserLocations().subscribe({
			next: (results: any) => this.locations.next(results),
			error: (err) => console.error('Failed to reload locations:', err)
		});
	}

	reloadingOrder(yesno: boolean) {
		this.reloadorder.next(yesno);
	}

	getDataSets() {
		this.globalsService.getDataSets().subscribe({
			next: (results: any) => this.datasets.next(results),
			error: (err) => console.error('Failed to load datasets:', err)
		});
	}

	hideSideBar() {
		const body = document.getElementsByTagName('body')[0];
		body.classList.remove('sidebar-mini');

		if (!body.classList.contains('sidebar-mini')) {
			this.collapseMini = true;
			body.classList.add('sidebar-mini');
			this.setNavState(this.collapseMini);
		}
	}

	getNavState() {
		return JSON.parse(localStorage.getItem('navstate'))
	}
	setNavState(inbound) {
		return localStorage.setItem('navstate', inbound);
	}


	public showNotification(message, type, from, align) {
		//  const type = ['','info','success','warning','danger'];
		// const color = Math.floor((Math.random() * 4) + 1);

		$.notify({
			icon: 'notifications',
			message: message

		}, {
			type: type,
			delay: 1000,
			z_index: 10009,
			timer: 1500,
			placement: {
				from: from,
				align: align
			},
			template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
				'<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
				'<i class="material-icons" data-notify="icon">notifications</i> ' +
				'<span data-notify="title">{1}</span> ' +
				'<span data-notify="message">{2}</span>' +
				'<div class="progress" data-notify="progressbar">' +
				'<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
				'</div>' +
				'<a href="{3}" target="{4}" data-notify="url"></a>' +
				'</div>'
		});
	}

	public filterItemO(input: any[], term: string, keys: string): any[] {
		if (!input?.length || !term?.trim() || !keys) {
			return input;
		}

		const regex = new RegExp(term.trim(), 'i');
		const keyArray = keys.split(',').map(key => key.trim()); // Trim keys to avoid extra spaces

		return input.filter(item =>
			keyArray.some(key => item[key] && regex.test(item[key]))
		);
	}


	public filterItem(input: any[], term: string, keys: string): any[] {
		if (!input || !term || !keys) {
			return input; // Return original array if no input, term, or keys
		}

		const normalizedTerm = (term || '').toString().trim().toLowerCase();

		const keyArray = keys.split(',').map(key => key.trim()); // Split and trim keys

		return input.filter(item =>
			keyArray.some(key => {
				const fieldValue = (item[key] || '').toString().toLowerCase(); // Normalize the field value
				return fieldValue.includes(normalizedTerm); // Check for partial match
			})
		);
	}


	public filterItemWord(input: any[], term: string, keys: string): any[] {
		if (!input || !term || !keys) {
			return input; // Return original if nothing to search
		}

		const lowerCaseTerm = term.toLowerCase(); // Convert search term to lowercase once
		const keyArray = keys.split(',').map(key => key.trim()); // Pre-split and trim keys

		return input.filter(item =>
			keyArray.some(key =>
				item[key]?.toString().toLowerCase().includes(lowerCaseTerm) // Case-insensitive partial match
			)
		);
	}




	public exportJsonToExcel(data: any, fileName: any) {
		import('xlsx').then(xlsx => {
			const worksheet = xlsx.utils.json_to_sheet(data);
			const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
			const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
			this.saveAsExcelFile(excelBuffer, fileName);
		});
	}

	public exportJsonToExcelWithTitle(title: string, subtitle: string, data: any[], fileName: string): void {
		if (!data || !data.length) return;
		import('xlsx').then(xlsx => {
			const headers = Object.keys(data[0]);
			const aoa: any[][] = [[title], [subtitle], [], headers, ...data.map(r => headers.map(h => r[h]))];
			const worksheet = xlsx.utils.aoa_to_sheet(aoa);
			const workbook = xlsx.utils.book_new();
			xlsx.utils.book_append_sheet(workbook, worksheet, 'Data');
			const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
			this.saveAsExcelFile(excelBuffer, fileName);
		});
	}

	public setConfig(config: any) {
		this.config = config;
		this.configsubscription.next(this.config);
	}

	public setColor(value: any): string {
		localStorage.setItem('color', JSON.stringify(value))
		this.color = value;
		return value;
	}

	public getColor(): string {
		let color = JSON.parse(localStorage.getItem('color'));
		if (color === null) {
			color = 'blue';
			localStorage.setItem('color', JSON.stringify('blue'))
		}
		this.color = color;
		return color;
	}
	//session miss behaing switch to storage
	public getSessionItem(name: string, ) {
		name = 'app'
		//JSON.parse(
		const check = localStorage.getItem(name);
		return check;
	}

	public setPackage(name: string, value: any) {
		const check = localStorage.getItem(name);
		if (check === null) {
			localStorage.setItem(name, value)
		}
		return value;
	}

	public setLocalItem(name: string, value: any) {
		const check = JSON.parse(localStorage.getItem(name));
		if (check === null) {
			localStorage.setItem(name, JSON.stringify(value))
		}
		return value;
	}

	public getLocalItem(name: string, ) {
		const check = JSON.parse(localStorage.getItem(name));
		return check;
	}

	exportPDF(element: any) {

		const html ='';

		const docDefinition = {
			pageSize: 'Letter',
			defaultStyle: {
				fontSize: 8,
			},
			content: html,
			styles: {
				table: {
					fontSize: 12,
				},
				anotherStyle: {
					italics: true,
					alignment: 'right'
				}
			},
			pageMargins: [40, 60, 40, 60],
		};

		//const documentDefinition = { content: html };
		//pdfMake.createPdf(docDefinition).download();
	}

	saveAsExcelFile(buffer: any, fileName: string): void {
		const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
		const EXCEL_EXTENSION = '.xlsx';
		const data: Blob = new Blob([buffer], {
			type: EXCEL_TYPE
		});
		FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
	}


	exportCSV(filename: string, rows: object[], headers ? : string[]): void {
		if (!rows || !rows.length) {
			return;
		}
		const separator = ',';

		const keys: string[] = Object.keys(rows[0]);

		let columHearders: string[];

		if (headers) {
			columHearders = headers;
		} else {
			columHearders = keys;
		}

		const csvContent =
			columHearders.join(separator) +
			'\n' +
			rows.map(row => {
				return keys.map(k => {
					let cell = row[k] === null || row[k] === undefined ? '' : row[k];

					cell = cell instanceof Date ?
						cell.toLocaleString() :
						cell.toString().replace(/"/g, '""');

					if (cell.search(/("|,|\n)/g) >= 0) {
						cell = `"${cell}"`;
					}
					return cell;
				}).join(separator);
			}).join('\n');

		const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		if (navigator.msSaveBlob) { // In case of IE 10+
			navigator.msSaveBlob(blob, filename);
		} else {
			const link = document.createElement('a');
			if (link.download !== undefined) {
				// Browsers that support HTML5 download attribute
				const url = URL.createObjectURL(blob);
				link.setAttribute('href', url);
				link.setAttribute('download', filename);
				link.style.visibility = 'hidden';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}
	}


	base64encode(str) {
		const encode = encodeURIComponent(str).replace(/%([a-f0-9]{2})/gi, (m, $1) => String.fromCharCode(parseInt($1, 16)))
		return btoa(encode)
	}

	base64decode(str) {
		const decode = atob(str).replace(/[\x80-\uffff]/g, (m) => `%${m.charCodeAt(0).toString(16).padStart(2, '0')}`)
		return decodeURIComponent(decode)
	}

	downloadXls(base64String, fileName) {
		const source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`;
		const link = document.createElement('a');
		link.href = source;
		link.download = `${fileName}`
		link.click();
	}

	downloadCsv(base64String, fileName) {
		const source = `data:application/csv;base64,${base64String}`;
		const link = document.createElement('a');
		link.href = source;
		link.download = `${fileName}`
		link.click();
	}


	downloadPdf(base64String, fileName) {
		const source = `data:application/pdf;base64,${base64String}`;
		const link = document.createElement('a');
		link.href = source;
		link.download = `${fileName}`
		link.click();
	}

	isEmail(search: string): boolean {
		let serchfind: boolean;
		const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
		serchfind = regexp.test(search);
		return serchfind
	}

	loadData() {

	}

	randomString(length: any, chars: any) {
		let result = '';
		for (let i = length; i > 0; --i) { result += chars[Math.floor(Math.random() * chars.length)]; }
		return result;
	}

	blurInputElement(inputElement: any) {
		const el = inputElement?.nativeElement ?? inputElement?._elementRef?.nativeElement ?? null;
		if (el && typeof el.blur === 'function') {
			el.blur();
		} else if (inputElement && typeof inputElement.blur === 'function') {
			inputElement.blur();
		}
	}

	getFormValidationErrors(form: any) {
		Object.keys(form.controls).forEach((key, index) => {
			const controlErrors: ValidationErrors = form.get(key).errors;
			if (controlErrors != null) {
				Object.keys(controlErrors).forEach(keyError => {
					//this.customerForm.controls[index].markAsTouched()
					form.markAllAsTouched();
					form.markAsUntouched()

					if (key == 'reference') {
						key = 'PO Number';
					}

					if (key == 'discountAmount') {
						key = 'Invalid Discount';
						keyError = '';
					}

					if (key == 'edireference') {
						key = 'Print Statement';
					}

					this.showNotification(key + ' ' + keyError, 'danger', 'bottom', 'right')
				});
			}
		});
	}

	updateLocations() {
		this.globalsService.getAllLocations().subscribe({
			next: (results: any) => this.locations.next(results),
			error: (err) => console.error('Failed to update locations:', err)
		});
	}

	/**
	 * Loccode for item browse QOH: navbar selected warehouse, else user default (object or string after location switch).
	 */
	resolveBrowseLoccode(): string {
		const sel = this.selectedlocation.value;
		if (sel != null && String(sel).trim() !== '') {
			return String(sel).trim();
		}
		const u = this.user.value;
		if (!u?.user) {
			return '';
		}
		const dl = u.user.defaultlocation;
		if (typeof dl === 'string' && dl.trim() !== '') {
			return dl.trim();
		}
		if (dl && typeof dl === 'object' && dl.loccode != null && String(dl.loccode).trim() !== '') {
			return String(dl.loccode).trim();
		}
		return '';
	}

	/** Merge a fresh `users/getuser` profile into the logged-in `{ pass, user }` session (localStorage + subjects). */
	mergeSessionUserProfile(profile: any): boolean {
		if (profile == null || typeof profile !== 'object') {
			return false;
		}
		const auth = this.user.getValue();
		if (!auth?.pass || !auth?.user) {
			return false;
		}
		const mergedUser = { ...auth.user, ...profile };
		const next = { ...auth, user: mergedUser };
		this.userData.next(mergedUser);
		this.user.next(next);
		localStorage.setItem('user', JSON.stringify(next));
		return true;
	}
}